/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _index = __webpack_require__(1);

	var _index2 = __webpack_require__(2);

	var _index3 = __webpack_require__(3);

	var _main = __webpack_require__(4);

	var _formulas = __webpack_require__(5);

	var _formulas2 = _interopRequireDefault(_formulas);

	var _hsoptimizer = __webpack_require__(6);

	var _hsoptimizer2 = _interopRequireDefault(_hsoptimizer);

	var _maths = __webpack_require__(7);

	var _maths2 = _interopRequireDefault(_maths);

	var _mechanics = __webpack_require__(8);

	var _mechanics2 = _interopRequireDefault(_mechanics);

	var _savedataanalyzer = __webpack_require__(9);

	var _savedataanalyzer2 = _interopRequireDefault(_savedataanalyzer);

	var _savedecoder = __webpack_require__(10);

	var _savedecoder2 = _interopRequireDefault(_savedecoder);

	var _exponential = __webpack_require__(11);

	var _exponential2 = _interopRequireDefault(_exponential);

	var _units = __webpack_require__(12);

	var _units2 = _interopRequireDefault(_units);

	var _numbertoexport = __webpack_require__(13);

	var _numbertoexport2 = _interopRequireDefault(_numbertoexport);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('clickerHeroes10Hsoptimizer', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ngRoute', 'ui.bootstrap', 'ngclipboard', 'rzModule']).config(_index.config).config(_index2.routerConfig).run(_index3.runBlock).value('maths', _maths2.default).service('formulas', _formulas2.default).service('mechanics', _mechanics2.default).service('hsoptimizer', _hsoptimizer2.default).service('saveDataAnalyzer', _savedataanalyzer2.default).service('saveDecoder', _savedecoder2.default).filter('exponential', _exponential2.default).filter('units', _units2.default).filter('numberToExport', _numbertoexport2.default).controller('MainController', _main.MainController);

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';

	config.$inject = ["$logProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.config = config;
	function config($logProvider) {
	  'ngInject';
	  // Enable log

	  $logProvider.debugEnabled(true);
	}

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';

	routerConfig.$inject = ["$routeProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerConfig = routerConfig;
	function routerConfig($routeProvider) {
	  'ngInject';

	  $routeProvider.when('/', {
	    templateUrl: 'app/main/main.html',
	    controller: 'MainController',
	    controllerAs: 'main'
	  }).otherwise({
	    redirectTo: '/'
	  });
	}

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';

	runBlock.$inject = ["$log"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runBlock = runBlock;
	function runBlock($log) {
	  'ngInject';

	  $log.debug('runBlock end');
	}

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';

	// TODO remove $scope when possible

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var MainController = exports.MainController = function () {
	  MainController.$inject = ["$scope", "$log", "saveDecoder", "formulas", "saveDataAnalyzer", "hsoptimizer", "mechanics"];
	  function MainController($scope, $log, saveDecoder, formulas, saveDataAnalyzer, hsoptimizer, mechanics) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, MainController);

	    this.mechanics = mechanics;

	    var resetForm = function resetForm() {
	      $scope.saveData = null;
	      $scope.hsInStock = 0;
	      $scope.ascendZone = 0;
	      $scope.ancients = [];
	      $scope.playStyle = "idle";
	      $scope.hsFromAscend = 0;
	      $scope.includeSoulsFromAscend = false;
	      $scope.asTotal = 0;
	      $scope.suggestHs = false;
	      $scope.error = undefined;

	      angular.element('#saveData').parent().removeClass('has-error');
	      $scope.useScientificNotation = false;
	      $scope.hybridRatio = 0.5;
	      $scope.slider.value = 0.5;
	    };

	    $scope.slider = {
	      value: 0.5,
	      options: {
	        stepsArray: [{ value: 0.1 }, { value: 0.2 }, { value: 0.3 }, { value: 0.4 }, { value: 0.5 }, { value: 0.6 }, { value: 0.7 }, { value: 0.8 }, { value: 0.9 }, { value: 1 }, { value: 1.5 }, { value: 2 }, { value: 2.5 }, { value: 3 }, { value: 4 }, { value: 5 }, { value: 6 }, { value: 7 }, { value: 8 }, { value: 9 }, { value: 10 }],
	        onChange: function onChange(id, value) {
	          $scope.hybridRatio = value;
	        }
	      }
	    };

	    resetForm();

	    $scope.$watch('encodedSaveData', function (encodedData) {
	      resetForm();

	      if (encodedData) {
	        try {
	          var saveData = saveDecoder.decryptSave(encodedData);
	          if (!saveDataAnalyzer.hasTranscended(saveData)) {
	            $scope.error = "Sorry, you need to have transcended at least once to use this calculator";
	            angular.element('#saveData').parent().addClass('has-error');
	          } else {
	            if (saveDataAnalyzer.detectPlayStyle(saveData)) {
	              $scope.suggestHs = true;
	            } else {
	              $scope.suggestHs = false;
	            }
	            $scope.saveData = saveData;
	          }
	        } catch (e) {
	          $log.debug(e);
	          $scope.error = "Save data is invalid";
	          angular.element('#saveData').parent().addClass('has-error');
	        }
	      }
	    });

	    $scope.$watch('saveData', function (saveData) {
	      if (saveData) {
	        $scope.hsInStock = saveDataAnalyzer.getHsInStock(saveData);
	        $scope.ascendZone = saveDataAnalyzer.getAscendZone(saveData);
	        $scope.playStyle = saveDataAnalyzer.detectPlayStyle(saveData) || "idle";
	        $scope.hsFromAscend = saveDataAnalyzer.getHsUponAscend(saveData);
	        $scope.useScientificNotation = saveDataAnalyzer.getNumberDisplayMode(saveData);
	        $scope.asTotal = saveDataAnalyzer.getAncientSoulsTotal(saveData);
	      }
	    });

	    // see http://stackoverflow.com/questions/21088845/can-i-debounce-or-throttle-a-watched-input-in-angularjs-using-lodash
	    // TODO debounce (lodash)
	    $scope.$watchGroup(['saveData', 'ascendZone', 'playStyle', 'includeSoulsFromAscend', 'hybridRatio'], function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 5),
	          saveData = _ref2[0],
	          ascendZone = _ref2[1],
	          playStyle = _ref2[2],
	          includeSoulsFromAscend = _ref2[3],
	          hybridRatio = _ref2[4];

	      if (saveData) {
	        var hs = $scope.hsInStock;
	        if (includeSoulsFromAscend) {
	          hs += $scope.hsFromAscend;
	        }
	        if ($scope.suggestHs) {
	          $scope.ancients = hsoptimizer.computeOptimumLevels(saveDataAnalyzer.getAncients(saveData), saveDataAnalyzer.getOutsiders(saveData), hs, ascendZone, saveDataAnalyzer.getAncientSoulsTotal(saveData), playStyle, hybridRatio);
	          var chorgorlothLevel = saveDataAnalyzer.getOutsiders($scope.saveData).filter(function (outsider) {
	            return outsider.name === 'Chor\'gorloth';
	          })[0].level;

	          $scope.totalCost = _this.totalCost(mechanics, $scope.ancients, chorgorlothLevel);
	        }

	        $scope.outsiders = hsoptimizer.computeOptimumAncientSouls(saveDataAnalyzer.getOutsiders(saveData), saveDataAnalyzer.getAncientSoulsTotal(saveData), playStyle);
	      }
	    });

	    $scope.getAncientUpgradeCost = function (name, currentLevel, newLevel) {
	      var chorgorlothLevel = saveDataAnalyzer.getOutsiders($scope.saveData).filter(function (outsider) {
	        return outsider.name === 'Chor\'gorloth';
	      })[0].level;
	      return mechanics.getAncientUpgradeCost(name, currentLevel, newLevel, chorgorlothLevel);
	    };

	    $scope.getOutsiderUpgradeCost = function (name, currentLevel, newLevel) {
	      return mechanics.getOutsiderUpgradeCost(name, currentLevel, newLevel);
	    };

	    // Must return $scope to be able to use the 'dot notation' in the view
	    // http://stackoverflow.com/questions/25306582/angulars-controlleras-not-working-in-routeprovider/38197324#38197324
	    return $scope;
	  }

	  _createClass(MainController, [{
	    key: 'totalCost',
	    value: function totalCost(mechanics, ancients, chorgorlothLevel) {
	      return ancients.reduce(function (total, ancient) {
	        return total + mechanics.getAncientUpgradeCost(ancient.name, ancient.level, ancient.optimumLevel, chorgorlothLevel);
	      }, 0);
	    }
	  }]);

	  return MainController;
	}();

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Formulas = function () {
	  function Formulas() {
	    'ngInject';

	    _classCallCheck(this, Formulas);
	  }

	  _createClass(Formulas, [{
	    key: 'computeMorgulisLevel',
	    value: function computeMorgulisLevel(baseLevel) {
	      return Math.pow(baseLevel, 2);
	    }
	  }, {
	    key: 'computeBubosLevel',
	    value: function computeBubosLevel(baseLevel, oldBubosLevel) {
	      return 2.8 * Math.log(baseLevel) - 1.4 * Math.log(1 + Math.exp(-0.02 * oldBubosLevel)) - 5.94;
	    }
	  }, {
	    key: 'computeChronosLevel',
	    value: function computeChronosLevel(baseLevel, oldChronosLevel) {
	      return 2.75 * Math.log(baseLevel) - 1.375 * Math.log(2 - Math.exp(-0.034 * oldChronosLevel)) - 5.1;
	    }
	  }, {
	    key: 'computeGoldLevel',
	    value: function computeGoldLevel(baseLevel) {
	      return 0.926 * baseLevel;
	    }
	  }, {
	    key: 'computeDoraLevel',
	    value: function computeDoraLevel(baseLevel, oldDoraLevel) {
	      return 2.877 * Math.log(baseLevel) - 1.4365 * Math.log(100 / 99 - Math.exp(-0.002 * oldDoraLevel)) - 9.63;
	    }
	  }, {
	    key: 'computeDogcogLevel',
	    value: function computeDogcogLevel(baseLevel, oldDogcogLevel) {
	      return 2.844 * Math.log(baseLevel) - 1.422 * Math.log(1 / 99 + Math.exp(-0.01 * oldDogcogLevel)) - 7.232;
	    }
	  }, {
	    key: 'computeFortunaLevel',
	    value: function computeFortunaLevel(baseLevel, oldFortunaLevel) {
	      return 2.875 * Math.log(baseLevel) - 1.4375 * Math.log(10 / 9 - Math.exp(-0.0025 * oldFortunaLevel)) - 9.3;
	    }
	  }, {
	    key: 'computeSolomonLevel',
	    value: function computeSolomonLevel(baseLevel, alpha) {
	      return Math.pow(baseLevel, 0.8) / Math.pow(alpha, 0.4);
	    }
	  }, {
	    key: 'computeAtmanLevel',
	    value: function computeAtmanLevel(baseLevel, oldAtmanLevel, alpha) {
	      return 2.832 * Math.log(baseLevel) - 1.416 * Math.log(alpha) - 1.416 * Math.log(4 / 3 - Math.exp(-0.013 * oldAtmanLevel)) - 6.613;
	    }
	  }, {
	    key: 'computeKumawakamaruLevel',
	    value: function computeKumawakamaruLevel(baseLevel, oldKumawakamaruLevel, alpha) {
	      return 2.844 * Math.log(baseLevel) - 1.422 * Math.log(alpha) - 1.422 * Math.log(0.25 + Math.exp(-0.01 * oldKumawakamaruLevel)) - 7.014;
	    }
	  }, {
	    key: 'computeNogardnitLevel',
	    value: function computeNogardnitLevel(baseLevel) {
	      return Math.pow(0.926 * baseLevel, 0.8);
	    }

	    // Formulas taken from https://kepow.org/clickerheroes
	    // and https://www.reddit.com/r/ClickerHeroes/comments/3y57jd/updated_rules_of_thumb/
	    // changed ratio from 0.1 to 0.5 in respect to original Rules of Thumb
	    // for a more active power !

	  }, {
	    key: 'computeHybridBhaalLevel',
	    value: function computeHybridBhaalLevel(baseLevel, hybridRatio) {
	      return hybridRatio * baseLevel;
	    }
	  }, {
	    key: 'computeHybridJuggernautLevel',
	    value: function computeHybridJuggernautLevel(baseLevel, hybridRatio) {
	      return Math.pow(hybridRatio * baseLevel, 0.8);
	    }
	  }, {
	    key: 'computeActiveJuggernautLevel',
	    value: function computeActiveJuggernautLevel(baseLevel) {
	      return Math.pow(baseLevel, 0.8);
	    }

	    // Alpha formula from: http://alexbonjour.github.io/rules-of-thumb/

	  }, {
	    key: 'computeAlpha',
	    value: function computeAlpha(tp, ascensionZone) {
	      var hpScale = Math.ceil(ascensionZone / 500) * 0.005 + 1.14;
	      return 1.4067 * Math.log(1 + tp) / Math.log(hpScale);
	    }

	    // TP formula from: https://www.reddit.com/r/ClickerHeroes/wiki/faqtranscendence

	  }, {
	    key: 'computeTranscendencePower',
	    value: function computeTranscendencePower(ancientSoulsTotal, phandoryssLevel) {
	      var baseTp = 50 - 49 * Math.exp(-ancientSoulsTotal / 10000);
	      var phandoryssBonus = 0.05 * phandoryssLevel;
	      return (baseTp + phandoryssBonus) / 100;
	    }

	    // Outsider formulas from: https://www.reddit.com/r/ClickerHeroes/comments/4rrbpi/math_outsiders_rule_of_thumb/

	  }, {
	    key: 'computeActiveXyliqil',
	    value: function computeActiveXyliqil() {
	      return 0;
	    }
	  }, {
	    key: 'computeHybridXyliqil',
	    value: function computeHybridXyliqil(ancientSoulsTotal) {
	      return Math.min(Math.floor(ancientSoulsTotal / 20), 5);
	    }
	  }, {
	    key: 'computeIdleXyliqil',
	    value: function computeIdleXyliqil(ancientSoulsTotal) {
	      return Math.min(Math.floor(ancientSoulsTotal / 5), 10);
	    }

	    /*
	    Phandoryss-Level	1	2	3	4	5	6	7	8	9	10
	    AS-Minimum	3	10	21	36	54	60	67	75	84	94
	    Phandoryss-Level	11	12	13	14	15	16	17	18	19
	    AS-Minimum	104	117	129	143	158	174	190	208	228
	    */

	  }, {
	    key: 'computePhandoryss',
	    value: function computePhandoryss(remainingAncientSouls) {
	      var table = [{ level: 1, as: 3 }, { level: 2, as: 10 }, { level: 3, as: 21 }, { level: 4, as: 36 }, { level: 5, as: 54 }, { level: 6, as: 60 }, { level: 7, as: 67 }, { level: 8, as: 75 }, { level: 9, as: 84 }, { level: 10, as: 94 }, { level: 11, as: 104 }, { level: 12, as: 117 }, { level: 14, as: 129 }, { level: 13, as: 143 }, { level: 15, as: 158 }, { level: 16, as: 174 }, { level: 17, as: 190 }, { level: 18, as: 208 }, { level: 19, as: 228 }];

	      return table.filter(function (e) {
	        return e.as <= remainingAncientSouls;
	      }).pop().level;
	    }
	  }, {
	    key: 'computeBorbA',
	    value: function computeBorbA(remainingAncientSouls) {
	      return Math.ceil(remainingAncientSouls / 10);
	    }
	  }, {
	    key: 'computePonyboy',
	    value: function computePonyboy(remainingAncientSouls) {
	      return Math.min(remainingAncientSouls, 19);
	    }
	  }, {
	    key: 'computeChorgorloth',
	    value: function computeChorgorloth(remainingAncientSouls) {
	      return Math.min(remainingAncientSouls, 10);
	    }
	  }, {
	    key: 'computeBorbD',
	    value: function computeBorbD(currentLevel, remainingAncientSouls) {
	      return Math.min(Math.max(10 - currentLevel, 0), remainingAncientSouls);
	    }
	  }, {
	    key: 'computeBorbE',
	    value: function computeBorbE(remainingAncientSouls) {
	      return Math.floor(remainingAncientSouls / 2);
	    }
	  }]);

	  return Formulas;
	}();

	exports.default = Formulas;

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var returnBaseLevel = function returnBaseLevel(baseLevel) {
	  return baseLevel;
	};

	var idleAndHybrid = function idleAndHybrid(formula) {
	  return function (playStyle) {
	    if (playStyle === 'idle' || playStyle === 'hybrid') {
	      return formula;
	    }
	  };
	};

	var activeOrHybrid = function activeOrHybrid(activeFormula, hybridFormula) {
	  return function (playStyle) {
	    if (playStyle === 'active') {
	      return activeFormula;
	    } else if (playStyle === 'hybrid') {
	      return hybridFormula;
	    }
	  };
	};

	var allStyles = function allStyles(formula) {
	  return function () {
	    return formula;
	  };
	};

	var HSOptimizer = function () {
	  HSOptimizer.$inject = ["formulas", "mechanics"];
	  function HSOptimizer(formulas, mechanics) {
	    'ngInject';

	    _classCallCheck(this, HSOptimizer);

	    this.formulas = formulas;
	    this.mechanics = mechanics;

	    // Khrysos, Thusia, Pluto and Iris don't exist anymore after transcending.
	    // They should be reintroduced in a pre-transcendent mode.
	    // No recommendation (yet) for Vaagur, Chawedo, Hecatoncheir, Berserker, Sniperino, Kleptos, Energon and Revolc.
	    this.ancientsOptimizedLevel = {
	      'Solomon': allStyles(function (baseLevel, old, alpha) {
	        return formulas.computeSolomonLevel(baseLevel, alpha);
	      }),
	      'Libertas': idleAndHybrid(formulas.computeGoldLevel),
	      'Siyalatas': idleAndHybrid(returnBaseLevel),
	      'Mammon': allStyles(formulas.computeGoldLevel),
	      'Mimzee': allStyles(formulas.computeGoldLevel),
	      'Dogcog': allStyles(formulas.computeDogcogLevel),
	      'Fortuna': allStyles(formulas.computeFortunaLevel),
	      'Atman': allStyles(formulas.computeAtmanLevel),
	      'Dora': allStyles(formulas.computeDoraLevel),
	      'Bhaal': activeOrHybrid(returnBaseLevel, function (baseLevel, old, alpha, hybridRatio) {
	        return formulas.computeHybridBhaalLevel(baseLevel, hybridRatio);
	      }),
	      'Morgulis': allStyles(formulas.computeMorgulisLevel),
	      'Chronos': allStyles(formulas.computeChronosLevel),
	      'Bubos': allStyles(formulas.computeBubosLevel),
	      'Fragsworth': activeOrHybrid(returnBaseLevel, function (baseLevel, old, alpha, hybridRatio) {
	        return formulas.computeHybridBhaalLevel(baseLevel, hybridRatio);
	      }),
	      'Kumawakamaru': allStyles(formulas.computeKumawakamaruLevel),
	      'Argaiv': allStyles(returnBaseLevel),
	      'Juggernaut': activeOrHybrid(formulas.computeActiveJuggernautLevel, function (baseLevel, old, alpha, hybridRatio) {
	        return formulas.computeHybridJuggernautLevel(baseLevel, hybridRatio);
	      }),
	      'Nogardnit': idleAndHybrid(formulas.computeNogardnitLevel)
	    };
	  }

	  _createClass(HSOptimizer, [{
	    key: 'computeOptimumLevels',
	    value: function computeOptimumLevels(ancientList, outsiders, hsInStock, ascendZone, ancientSoulsTotal, playStyle, hybridRatio) {
	      var _this = this;

	      var phandoryssLevel = outsiders.filter(function (outsider) {
	        return outsider.name === 'Phandoryss';
	      })[0].level;
	      var chorgorlothLevel = outsiders.filter(function (outsider) {
	        return outsider.name === 'Chor\'gorloth';
	      })[0].level;

	      var baseLevel = 1;

	      // TODO add soul bank when Morgulis has not been summon
	      // const hasMorgulis = ancientList.some(ancient => ancient.name === 'Morgulis');

	      var tp = this.formulas.computeTranscendencePower(ancientSoulsTotal, phandoryssLevel);
	      var alpha = this.formulas.computeAlpha(tp, ascendZone);

	      var remainingHs = hsInStock;
	      var baseLevelIncrease = 0;

	      var computeNewLevel = function computeNewLevel(ancientName, playStyle, newBaseLevel, oldLevel, alpha, hybridRatio) {
	        var optimizationFormula = _this.ancientsOptimizedLevel[ancientName];
	        if (optimizationFormula) {
	          var playStyleForumla = optimizationFormula(playStyle);
	          if (playStyleForumla) {
	            return playStyleForumla(newBaseLevel, oldLevel, alpha, hybridRatio);
	          }
	        }
	      };

	      var normalize = function normalize(oldLevel, newLevel) {
	        if (oldLevel === 0) {
	          return 0;
	        }
	        if (newLevel === undefined) {
	          return undefined;
	        }
	        return Math.max(oldLevel, Math.round(newLevel));
	      };

	      var computeNewLevels = function computeNewLevels(currentAncients, newBaseLevel, alpha, hybridRatio) {
	        return currentAncients.map(function (ancient) {
	          return {
	            name: ancient.name,
	            currentLevel: ancient.level,
	            optimizedLevel: normalize(ancient.level, computeNewLevel(ancient.name, playStyle, newBaseLevel, ancient.level, alpha, hybridRatio))
	          };
	        }).filter(function (ancient) {
	          return ancient.optimizedLevel !== undefined;
	        });
	      };

	      var getCost = function getCost(ancientLevels, chorgorlothLevel) {
	        return ancientLevels.reduce(function (totalCost, ancient) {
	          return totalCost + _this.mechanics.getAncientUpgradeCost(ancient.name, ancient.currentLevel, ancient.optimizedLevel, chorgorlothLevel);
	        }, 0);
	      };

	      // Okay this is a little bit magic... and approximate also, but it's fast !
	      // TODO maybe switch to a more simple dichotomy
	      var baseOffset = 0;
	      var lastBaseOffset = -1;
	      // Continue until we are no longer able to increase the level without spending more HS than we have,
	      // or until (for large numbers) the next iteration of level increases costs less HS than the available precision
	      while (baseOffset != lastBaseOffset && (remainingHs >= 0 || baseLevelIncrease > 0)) {
	        lastBaseOffset = baseOffset;
	        remainingHs = hsInStock;
	        baseLevelIncrease = -1;
	        while (remainingHs >= 0) {
	          baseLevelIncrease++;
	          var levelToCheck = baseLevel + baseOffset + Math.pow(2, baseLevelIncrease);
	          var newLevels = computeNewLevels(ancientList, levelToCheck, alpha, hybridRatio);
	          remainingHs = hsInStock - getCost(newLevels, chorgorlothLevel);
	        }
	        if (baseLevelIncrease > 0) {
	          baseOffset += Math.pow(2, baseLevelIncrease - 1);
	        }
	      }
	      var newBaseLevel = baseLevel + baseOffset;

	      var optimumAncients = ancientList.map(function (ancient) {
	        var optimumLevel = normalize(ancient.level, computeNewLevel(ancient.name, playStyle, newBaseLevel, ancient.level, alpha, hybridRatio));
	        return {
	          name: ancient.name,
	          level: ancient.level,
	          optimumLevel: optimumLevel,
	          delta: optimumLevel - ancient.level };
	      }).filter(function (ancient) {
	        return ancient.optimumLevel !== undefined;
	      });
	      return optimumAncients;
	    }
	  }, {
	    key: 'computeOptimumAncientSouls',
	    value: function computeOptimumAncientSouls(outsiderList, ancientSoulsTotal, playStyle) {
	      var currentXyliqilLevel = outsiderList.filter(function (outsider) {
	        return outsider.name === 'Xyliqil';
	      })[0].level;
	      var currentChorgorlothLevel = outsiderList.filter(function (outsider) {
	        return outsider.name === 'Chor\'gorloth';
	      })[0].level;
	      var currentPhandoryssLevel = outsiderList.filter(function (outsider) {
	        return outsider.name === 'Phandoryss';
	      })[0].level;
	      var currentBorbLevel = outsiderList.filter(function (outsider) {
	        return outsider.name === 'Borb';
	      })[0].level;
	      var currentPonyboyLevel = outsiderList.filter(function (outsider) {
	        return outsider.name === 'Ponyboy';
	      })[0].level;

	      var remainingAncientSouls = ancientSoulsTotal;
	      var xyliqilTargetLevel = void 0;
	      if (playStyle === 'idle') {
	        xyliqilTargetLevel = this.formulas.computeIdleXyliqil(ancientSoulsTotal);
	      } else if (playStyle === 'active') {
	        xyliqilTargetLevel = this.formulas.computeActiveXyliqil(ancientSoulsTotal);
	      } else if (playStyle === 'hybrid') {
	        xyliqilTargetLevel = this.formulas.computeHybridXyliqil(ancientSoulsTotal);
	      }
	      remainingAncientSouls -= this.mechanics.getOutsiderUpgradeCost('Xyliqil', 0, xyliqilTargetLevel);
	      var phandoryssTargetLevel = this.formulas.computePhandoryss(remainingAncientSouls);
	      remainingAncientSouls -= this.mechanics.getOutsiderUpgradeCost('Phandoryss', 0, phandoryssTargetLevel);
	      var borbTargetLevelA = this.formulas.computeBorbA(remainingAncientSouls);
	      remainingAncientSouls -= this.mechanics.getOutsiderUpgradeCost('Borb', 0, borbTargetLevelA);
	      var ponyTargetLevelB = this.formulas.computePonyboy(remainingAncientSouls);
	      remainingAncientSouls -= this.mechanics.getOutsiderUpgradeCost('Ponyboy', 0, ponyTargetLevelB);
	      var chorTargetLevelC = this.formulas.computeChorgorloth(remainingAncientSouls);
	      remainingAncientSouls -= this.mechanics.getOutsiderUpgradeCost('Chor\'gorloth', 0, chorTargetLevelC);
	      var borbTargetLevelD = this.formulas.computeBorbD(borbTargetLevelA, remainingAncientSouls);
	      if (borbTargetLevelA < borbTargetLevelD) {
	        remainingAncientSouls -= this.mechanics.getOutsiderUpgradeCost('Borb', borbTargetLevelA, borbTargetLevelD);
	      }
	      var borbTargetLevelE = this.formulas.computeBorbE(remainingAncientSouls);
	      var intermediateBorbLevel = Math.max(borbTargetLevelA, borbTargetLevelD);
	      remainingAncientSouls -= this.mechanics.getOutsiderUpgradeCost('Borb', intermediateBorbLevel, intermediateBorbLevel + borbTargetLevelE);
	      var ponyTargetLevelE = remainingAncientSouls;
	      return [{ name: 'Xyliqil', order: 1, level: currentXyliqilLevel, optimumLevel: xyliqilTargetLevel }, { name: 'Chor\'gorloth', order: 2, level: currentChorgorlothLevel, optimumLevel: chorTargetLevelC }, { name: 'Phandoryss', order: 3, level: currentPhandoryssLevel, optimumLevel: phandoryssTargetLevel }, { name: 'Borb', order: 4, level: currentBorbLevel, optimumLevel: intermediateBorbLevel + borbTargetLevelE }, { name: 'Ponyboy', order: 5, level: currentPonyboyLevel, optimumLevel: ponyTargetLevelB + ponyTargetLevelE }];
	    }
	  }]);

	  return HSOptimizer;
	}();

	exports.default = HSOptimizer;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'linear': {
	    'unit': function unit(n) {
	      return n;
	    },
	    'sum': function sum(n) {
	      return n * (n + 1) / 2;
	    } },
	  'linear10': {
	    'unit': function unit(n) {
	      return Math.ceil(n / 10);
	    },
	    'sum': function sum(n) {
	      return Math.ceil(n * (n + 1) / 20);
	    } },
	  'constant': {
	    'unit': function unit() {
	      return 1;
	    },
	    'sum': function sum(n) {
	      return n + 1;
	    } },
	  'exponential': {
	    'unit': function unit(n) {
	      return Math.pow(2, n);
	    },
	    'sum': function sum(n) {
	      return Math.pow(2, n + 1) - 1;
	    } },
	  'polynomial1_5': {
	    'unit': function unit(n) {
	      return Math.ceil(Math.pow(n, 1.5));
	    },
	    // Using approximation from Euler-Maclaurin formula:
	    // https://en.wikipedia.org/wiki/Euler%E2%80%93Maclaurin_formula#The_formula
	    // Inspired by;
	    // http://math.stackexchange.com/questions/1393811/sum-of-1-5-powers-of-natural-numbers
	    // return Infinity when n = 0, it should be 0, can be added as an 'exception'
	    // return 2 when n = 1, it should be 1, can be added as an 'exception'
	    'sumApprox': function sumApprox(n) {
	      return n === 0 ? 0 : Math.ceil(2 * Math.pow(n, 2.5) / 5 + Math.pow(n, 1.5) / 2 + Math.pow(n, 0.5) / 8 + Math.pow(n, -1.5) / 1920);
	    } },
	  'sum': function sum(fn) {
	    return function (n) {
	      var sum = 0;
	      for (var i = 0; i <= n; i++) {
	        sum += fn(i);
	      }
	      return sum;
	    };
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Mechanics = function () {
	  Mechanics.$inject = ["maths"];
	  function Mechanics(maths) {
	    'ngInject';

	    _classCallCheck(this, Mechanics);

	    this.ancients = {
	      "Solomon": { id: "3", cost: maths.polynomial1_5 },
	      "Libertas": { id: "4", cost: maths.linear },
	      "Siyalatas": { id: "5", cost: maths.linear },
	      // Khrysos "6", quadratic
	      // Thusia "7", quadratic
	      "Mammon": { id: "8", cost: maths.linear },
	      "Mimzee": { id: "9", cost: maths.linear },
	      // Pluto "10", linear
	      "Dogcog": { id: "11", cost: maths.exponential },
	      "Fortuna": { id: "12", cost: maths.exponential },
	      "Atman": { id: "13", cost: maths.exponential },
	      "Dora": { id: "14", cost: maths.exponential },
	      "Bhaal": { id: "15", cost: maths.linear },
	      "Morgulis": { id: "16", cost: maths.constant },
	      "Chronos": { id: "17", cost: maths.exponential },
	      "Bubos": { id: "18", cost: maths.exponential },
	      "Fragsworth": { id: "19", cost: maths.linear },
	      "Vaagur": { id: "20", cost: maths.exponential },
	      "Kumawakamaru": { id: "21", cost: maths.exponential },
	      "Chawedo": { id: "22", cost: maths.exponential },
	      "Hecatoncheir": { id: "23", cost: maths.exponential },
	      "Berserker": { id: "24", cost: maths.exponential },
	      "Sniperino": { id: "25", cost: maths.exponential },
	      "Kleptos": { id: "26", cost: maths.exponential },
	      "Energon": { id: "27", cost: maths.exponential },
	      "Argaiv": { id: "28", cost: maths.linear },
	      "Juggernaut": { id: "29", cost: maths.polynomial1_5 },
	      // Iris "30", quadratic
	      "Revolc": { id: "31", cost: maths.exponential },
	      "Nogardnit": { id: "32", cost: maths.polynomial1_5 }
	    };

	    this.outsiders = {
	      "Xyliqil": { id: "1", cost: maths.constant },
	      "Chor'gorloth": { id: "2", cost: maths.linear10 },
	      "Phandoryss": { id: "3", cost: maths.linear },
	      "Borb": { id: "4", cost: maths.constant },
	      "Ponyboy": { id: "5", cost: maths.constant }
	    };

	    this.sum = maths.sum;
	  }

	  _createClass(Mechanics, [{
	    key: 'getAncientCostSum',
	    value: function getAncientCostSum(name) {
	      return this.ancients[name].cost.sum || this.ancients[name].cost.sumApprox;
	    }
	  }, {
	    key: 'getAncientNameById',
	    value: function getAncientNameById(id) {
	      for (var ancient in this.ancients) {
	        if (this.ancients[ancient].id === id) {
	          return ancient;
	        }
	      }
	    }
	  }, {
	    key: 'getAncientCost',
	    value: function getAncientCost(name) {
	      return this.ancients[name].cost.unit;
	    }
	  }, {
	    key: 'getAncientCostMultiplier',
	    value: function getAncientCostMultiplier(chorgorlothLevel) {
	      return Math.pow(0.95, chorgorlothLevel);
	    }

	    // Check edges (+/-1 on edges)

	  }, {
	    key: 'getAncientUpgradeCost',
	    value: function getAncientUpgradeCost(name, currentLevel, newLevel) {
	      var chorgorlothLevel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

	      return Math.ceil((this.getAncientCostSum(name)(newLevel) - this.getAncientCostSum(name)(currentLevel)) * this.getAncientCostMultiplier(chorgorlothLevel));
	    }
	  }, {
	    key: 'getOutsiderNameById',
	    value: function getOutsiderNameById(id) {
	      for (var outsider in this.outsiders) {
	        if (this.outsiders[outsider].id === id) {
	          return outsider;
	        }
	      }
	    }
	  }, {
	    key: 'getOutsiderUpgradeCost',
	    value: function getOutsiderUpgradeCost(name, currentLevel, newLevel) {
	      var sum = this.sum(this.outsiders[name].cost.unit);
	      return sum(newLevel) - sum(currentLevel);
	    }
	  }]);

	  return Mechanics;
	}();

	exports.default = Mechanics;

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var playStyleReducer = function playStyleReducer(style1, style2) {
	  return style1 && style2 ? "hybrid" : style1 || style2;
	};

	var SaveDataAnalyzer = function () {
	  SaveDataAnalyzer.$inject = ["mechanics"];
	  function SaveDataAnalyzer(mechanics) {
	    'ngInject';

	    _classCallCheck(this, SaveDataAnalyzer);

	    this.mechanics = mechanics;
	  }

	  _createClass(SaveDataAnalyzer, [{
	    key: 'getAncients',
	    value: function getAncients(saveData) {
	      var _this = this;

	      return Object.keys(saveData.ancients.ancients).map(function (id) {
	        return {
	          name: _this.mechanics.getAncientNameById(id),
	          level: Math.floor(saveData.ancients.ancients[id].level) };
	      });
	    }
	  }, {
	    key: 'getOutsiders',
	    value: function getOutsiders(saveData) {
	      var _this2 = this;

	      return Object.keys(saveData.outsiders.outsiders).map(function (id) {
	        return {
	          name: _this2.mechanics.getOutsiderNameById(id),
	          level: Math.round(saveData.outsiders.outsiders[id].level) };
	      });
	    }
	  }, {
	    key: 'getHsInStock',
	    value: function getHsInStock(saveData) {
	      return Math.round(saveData.heroSouls);
	    }
	  }, {
	    key: 'getHsUponAscend',
	    value: function getHsUponAscend(saveData) {
	      return Math.round(saveData.primalSouls);
	    }
	  }, {
	    key: 'getAncientSoulsTotal',
	    value: function getAncientSoulsTotal(saveData) {
	      return Math.round(saveData.ancientSoulsTotal);
	    }
	  }, {
	    key: 'getAscendZone',
	    value: function getAscendZone(saveData) {
	      return Math.round(saveData.highestFinishedZonePersist);
	    }
	  }, {
	    key: 'detectPlayStyle',
	    value: function detectPlayStyle(saveData) {
	      return this.getAncients(saveData).filter(function (ancient) {
	        return ancient.name === "Siyalatas" || ancient.name === "Fragsworth";
	      }).map(function (ancient) {
	        return ancient.name === "Siyalatas" ? "idle" : "active";
	      }).reduce(playStyleReducer, undefined);
	    }
	  }, {
	    key: 'hasTranscended',
	    value: function hasTranscended(saveData) {
	      return !!saveData.transcendent;
	    }
	  }, {
	    key: 'getNumberDisplayMode',
	    value: function getNumberDisplayMode(saveData) {
	      return !!saveData.numberDisplayMode;
	    }
	  }]);

	  return SaveDataAnalyzer;
	}();

	exports.default = SaveDataAnalyzer;

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';

	// Ignoring foreign code
	// Almost entirely taken from:
	// https://github.com/DobruJ01/clicker-lister/blob/master/common/saveDecoder.js
	/* eslint-disable */
	/*
	  ==================================================
	  Contains the savefile decoding code. Most of it is
	  adapted from other sources. I didn't think to save
	  the source at the time, if you recognize your code
	  and want credit for it, let me know.
	  ==================================================
	*/

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ANTI_CHEAT_CODE = 'Fe12NAfA3R6z4k0z';
	var SALT = 'af0ik392jrmt0nsfdghy0';

	function _decryptSave(string) {
	  // Find anticheatcode
	  var antiCheatCodeIndex = string.search(ANTI_CHEAT_CODE);
	  // If found, convert string from anticheatformat
	  if (antiCheatCodeIndex != -1) string = fromAntiCheatFormat(string);
	  // Then decrypt the result using standard base 64 decryption
	  var jsonString = atob(string);

	  return JSON.parse(jsonString);
	}

	function fromAntiCheatFormat(string) {
	  // Separate the things by the anticheatcode
	  var elements = string.split(ANTI_CHEAT_CODE);
	  // Unsprinkle the actual save
	  var data = unSprinkle(elements[0]);
	  // Get the hash
	  var hash = elements[1];
	  // Calculate the actual hash from the data
	  var dataHash = getHash(data);
	  // Check if the calculated hash is the same as the given hash, if yes then return the data
	  if (dataHash = hash) return data;
	  alert("Hash is bad");
	}

	function unSprinkle(string) {
	  // Unsprinkles the save. Sprinkle adds randomized elements after every character. Split by "" to separate it all into separate spots in the array.
	  // Splitting the array isn't strictly necessary. Strings are technically an array of letters. Might try to remove the splitting and see if it still works.

	  var array = string.split("");
	  // Empty array for the result.
	  var result = [];
	  var counter = 0;

	  // Until we reach the end of the string...
	  while (counter < array.length) {
	    // Take a letter, add it to the new array at half the value it was at from the start. 0 becomes 0. 2 becomes 1. 4 becomes 2. 6 becomes 3. etc.
	    result[counter / 2] = array[counter];
	    // Advancing by two steps skips every other letter, effectively unsprinkling it.
	    counter += 2;
	  }
	  return result.join("");
	}

	function getHash(string) {
	  // Split the string up. Again, not strictly necessary, might change at some point.
	  var characters = string.split();
	  // Sort the string. The hash doesn't need to be decrypted, only encrypted, thus the actual data isn't preserved.
	  characters.sort();
	  // Joins the characters into a variable. Not sure if this step is necessary either.
	  var sortedcharacters = characters.join();
	  // Returns and MD5 hash. Not the most secure of hashes, but functional and suitable for our uses.
	  return CryptoJS.MD5(sortedcharacters + SALT);
	}

	/* eslint-enable */

	var SaveDecoder = function () {
	  function SaveDecoder() {
	    'ngInject';

	    _classCallCheck(this, SaveDecoder);
	  }

	  _createClass(SaveDecoder, [{
	    key: 'decryptSave',
	    value: function decryptSave(encodedSaveData) {
	      return _decryptSave(encodedSaveData);
	    }
	  }]);

	  return SaveDecoder;
	}();

	exports.default = SaveDecoder;

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exponential;
	function exponential() {
	  return function (input) {
	    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000;

	    if (input <= limit) {
	      return input.toLocaleString();
	    }
	    return input.toExponential(3).replace('+', '');
	  };
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	exports.default = units;
	function units() {
	  var suffixes = ['', 'K', 'M', 'B', 'T', 'q', 'Q', 's', 'S', 'O', 'N', 'd', 'U', 'D', '!', '@', '#', '$', '%', '^', '&', '*'];
	  var formatScientificNotation = function formatScientificNotation(input) {
	    return input.toExponential(3).replace('+', '');
	  };
	  var formatWithSuffix = function formatWithSuffix(input, order) {
	    return Math.round(input / Math.pow(1000, order)).toLocaleString('en-US') + suffixes[order];
	  };
	  var formatWithoutSuffix = function formatWithoutSuffix(input) {
	    return formatWithSuffix(input, 0);
	  };

	  return function (input) {
	    var scientificNotation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	    if (scientificNotation) {
	      if (Math.abs(input) <= 100000) {
	        return formatWithoutSuffix(input);
	      }
	      return formatScientificNotation(input);
	    } else {
	      var log10 = void 0;
	      if (_typeof(Math.log10) !== ( true ? 'undefined' : _typeof(undefined))) {
	        log10 = Math.log10;
	      } else {
	        log10 = function log10(x) {
	          return Math.log(x) / Math.log(10);
	        };
	      }

	      var order = Math.max(Math.floor((log10(Math.abs(input)) - 2) / 3), 0);
	      if (order >= suffixes.length) {
	        return formatScientificNotation(input);
	      }

	      var _formatWithSuffix = function _formatWithSuffix(input, order) {
	        return Math.round(input / Math.pow(1000, order)).toLocaleString('en-US') + suffixes[order];
	      };
	      return _formatWithSuffix(input, order);
	    }
	  };
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	exports.default = numberToExport;
	function numberToExport() {
	  var limit = 1e20;

	  var getLog10 = function getLog10() {
	    if (_typeof(Math.log10) !== ( true ? "undefined" : _typeof(undefined))) {
	      return Math.log10;
	    } else {
	      return function (x) {
	        return Math.log(x) / Math.log(10);
	      };
	    }
	  };

	  var integralScientificNotation = function integralScientificNotation(input) {
	    var log10 = getLog10();
	    var exponent = Math.floor(log10(input));
	    var integralExponent = exponent - 10;
	    var integralSignificand = Math.floor(input / Math.pow(10, integralExponent));
	    return integralSignificand + "e" + integralExponent;
	  };

	  return function (input) {
	    if (input > limit) {
	      return integralScientificNotation(input);
	    }

	    return input.toString();
	  };
	}

/***/ }
/******/ ]);
angular.module('clickerHeroes10Hsoptimizer').run(['$templateCache', function($templateCache) {$templateCache.put('app/main/main.html','<div class=header> <div class=container> <h1>Clicker Heroes 1.0 HS Optimizer</h1> </div> </div> <div class=container> <div class=row> <p>This calculator is based on <a href=https://www.reddit.com/r/ClickerHeroes/comments/4naohc/math_and_transcendance><strong>Math and Transcendance</strong></a> by <a href=https://www.reddit.com/user/sugima>/u/sugima</a> and <a href=https://www.reddit.com/r/ClickerHeroes/comments/3y57jd/updated_rules_of_thumb/ ><strong>Updated Rules of Thumb!</strong></a> by <a href=https://www.reddit.com/user/TinDragon>/u/TinDragon</a> for HS optimization and <a href=https://www.reddit.com/r/ClickerHeroes/comments/4rrbpi/math_outsiders_rule_of_thumb/ ><strong>[Math] Outsiders - Rule of Thumb</strong></a> by <a href=https://www.reddit.com/user/Stratege1337>/u/Stratege1337</a> for AS optimization. Nogardnit level is taken from <a href=https://www.reddit.com/r/ClickerHeroes/comments/5dc7y9/anyone_done_the_math_on_nogardtin_yet/ ><strong>Anyone done the math on Nogardtin yet?</strong></a>.</p> <p>It can compute optimized ancients and outsiders levels using idle, active and hybrid builds.</p> <p>You need to have transcended at least once to make the calculator work.</p> <p>You need at least Siyalatas or Fragsworth at level 1 to have HS suggestions.</p> <p>Source code is <a href=https://www.github.com/superbob/clicker-heroes-1.0-hsoptimizer>here</a>, feel free to open to <a href=https://github.com/superbob/clicker-heroes-1.0-hsoptimizer/issues>issues</a> and <a href=https://github.com/superbob/clicker-heroes-1.0-hsoptimizer/pulls>pull requests</a>.</p> <p>Announcement and discussions on <a href=https://www.reddit.com/r/ClickerHeroes/comments/4qhud9/transcendence_hs_optimizer>/r/ClickerHeroes/comments/4qhud9/transcendence_hs_optimizer</a>. </p></div> <div class=row> <div class="panel panel-default"> <div class=panel-heading>Data</div> <div class=panel-body> <div class=col-md-4> <form> <div class=form-group> <label for=saveData>Save data</label> <textarea class=form-control id=saveData rows=3 placeholder="Paste your save data here" ng-model=main.encodedSaveData autofocus></textarea> </div> <p class=text-danger ng-show=main.error>{{main.error}}</p> </form> </div> <form class=form-inline> <div class=col-md-4> <div class=form-group> <label for=ascendZone>Ascend zone</label> <input type=text class=form-control id=ascendZone ng-model=main.ascendZone> </div> <div class=form-group> <div class=checkbox> <label> <input type=checkbox ng-model=main.includeSoulsFromAscend>Include souls from ascension<span ng-if=main.saveData> (+{{main.hsFromAscend | units:useScientificNotation}})</span> </label> </div> </div> <div class=form-group> <div class=checkbox> <label> <input type=checkbox ng-model=main.useScientificNotation>Use scientific notation </label> </div> </div> </div> <div class=col-md-4> <div class=row> <div class=form-group> <label>Playstyle</label> <div class=radio> <label> <input type=radio name=playstyle id=playStyleIdle value=idle ng-model=main.playStyle checked> Idle </label> </div> <div class=radio> <label> <input type=radio name=playstyle id=playStyleHybrid value=hybrid ng-model=main.playStyle> Hybrid </label> </div> <div class=radio> <label> <input type=radio name=playstyle id=playStyleActive value=active ng-model=main.playStyle> Active </label> </div> </div> </div> <div class=row ng-if="main.playStyle == \'hybrid\'"> <div class=form-group> Hybrid Idle/Active ratio <rzslider rz-slider-model=main.slider.value rz-slider-options=main.slider.options></rzslider> </div> </div> </div> </form> </div> </div> </div> <div class=row ng-if=main.saveData> <div class=col-md-6 ng-if=!main.suggestHs> <p>You need at least Siyalatas or Fragsworth to have HS suggestions.</p> </div> <div class=col-md-6 ng-if=main.suggestHs> <p>You have {{main.hsInStock | units:useScientificNotation}} HS in stock.</p> <table class="table table-striped table-condensed"> <thead> <tr> <th>Ancient</th> <th>Current</th> <th>Goal</th> <th>Delta</th> <th>Cost (HS)</th> </tr> </thead> <tbody> <tr ng-repeat="ancient in main.ancients | orderBy : \'name\'"> <td>{{ancient.name}}</td> <td>{{ancient.level | units:useScientificNotation}}</td> <td>{{ancient.optimumLevel | units:useScientificNotation}}</td> <td><strong><a class=selectable ngclipboard data-clipboard-text="{{ancient.optimumLevel - ancient.level | numberToExport}}" uib-tooltip="Click to copy {{ancient.optimumLevel - ancient.level | numberToExport}} to clipboard" tooltip-placement=right>+{{ancient.optimumLevel - ancient.level | units:useScientificNotation}}</a></strong></td> <td>{{main.getAncientUpgradeCost(ancient.name, ancient.level, ancient.optimumLevel) | units:useScientificNotation}}</td> </tr> </tbody> <tfoot> <tr> <th colspan=4><strong>Total cost</strong></th> <th><strong>{{main.totalCost | units:useScientificNotation}}</strong></th> </tr> </tfoot> </table> </div> <div class=col-md-6> <p>You have {{main.asTotal | units:useScientificNotation}} total AS.</p> <table class="table table-striped table-condensed"> <thead> <tr> <th>Outsider</th> <th>Goal</th> <th>Cost (AS)</th> </tr> </thead> <tbody> <tr ng-repeat="outsider in main.outsiders | orderBy : \'order\'"> <td>{{outsider.name}}</td> <td>{{outsider.optimumLevel | units:useScientificNotation}}</td> <td>{{main.getOutsiderUpgradeCost(outsider.name, 0, outsider.optimumLevel) | units:useScientificNotation}}</td> </tr> </tbody> </table> <p class=text-warning>Warning: These suggestions don\'t consider your existing levels of outsiders. It consider total AS, optimum levels and costs from zero.</p> </div> </div> <div class=row> <div class="panel panel-default"> <div class=panel-heading>More Info</div> <div class=panel-body> <p>This optimizer is primarly based on <a href=https://www.reddit.com/r/ClickerHeroes/comments/4naohc/math_and_transcendance>these formulas</a> by <a href=https://www.reddit.com/user/sugima>/u/sugima</a> for idle builds.</p> <p><a href=https://www.reddit.com/r/ClickerHeroes/comments/3y57jd/updated_rules_of_thumb/ >Older formulas</a> by <a href=https://www.reddit.com/user/TinDragon>/u/TinDragon</a> are used to compute active and hybrid builds.</p> <p> Finally, <a href=https://www.reddit.com/r/ClickerHeroes/comments/4rrbpi/math_outsiders_rule_of_thumb/ >these formulas</a> by <a href=https://www.reddit.com/user/Stratege1337>/u/Stratege1337</a> are used to compute AS optimization for any build. Be careful, AS optimization is highly experimental as it is not base on "hard" math. </p> <p>Also, <a href=https://www.reddit.com/user/Shruikan864>/u/Shruikan864</a>\'s <a href=https://www.reddit.com/r/ClickerHeroes/comments/4nox6i/rules_of_thumb_10_spreadsheet/ >Rules of Thumb 1.0 Spreadsheet</a> was used to get and verify some important formulas (Chor multiplier, TP, alpha, ...).</p> <p>Important variations with other calculators can come from rounding, as a "round to the nearest integer" is applied in computed optimized ancient levels instead of a floor that can be seen in other calculators (such as <a href=https://kepow.org/clickerheroes>kepow</a> or <em>Rules of Thumb 1.0 Spreadsheet</em>).</p> </div> </div> </div> </div> ');}]);